<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      class="ol-xs-12 mycol content-mb-14"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_PRIORITI_COMPLECT_AUTO'
        )
      }"
    >
      <Multiselect
        label="NAME"
        class="i-main-style i-wid-50 stl-bs_bb multiselect-filter-project-register multiselect-multiline"
        :limit="50"
        :limitText="filterItemText"
        track-by="ID"
        v-model="project.UF_PRIORITI_COMPLECT_AUTO"
        :options="directory.sp_priority_components_auto"
        :multiple="true"
        placeholder=""
      />
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_PRIORITI_COMPLECT_AUTO"
          )
        }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Multiselect from "vue-multiselect";

export default {
  name: "uf_is_ndt",
  computed: {
    ...mapGetters(["directory", "project"])
  },
  components: {
    Multiselect
  },
  methods: {
    filterItemText(count) {
      console.log(count);
      return ``;
    },
    inArray(needle, haystack) {
      var length = haystack.length;
      for (var i = 0; i < length; i++) {
        if (haystack[i] == needle) return true;
      }
      return false;
    }
  }
};
</script>

<style scoped></style>
